import React from "react";
import {
  ShieldCheck,
  Lock,
  Search,
  Zap
} from "lucide-react";

import Navigation from "../components/Navigation";
import FooterSection from "../components/FooterSection";
import "./CookiePolicy.css";

const CookiePolicy = () => {
  const cookieCategories = [
    {
      id: "essential",
      title: "Essential Cookies",
      icon: Lock,
      desc: "Required for login, security, and basic app functionality.",
      items: [
        {
          name: "MEDICO_SESSION_ID",
          purpose: "Keeps user session active and secure."
        },
        {
          name: "AUTH_TOKEN_SECURE",
          purpose: "Stores login authentication safely."
        }
      ]
    },
    {
      id: "performance",
      title: "Performance Cookies",
      icon: Zap,
      desc: "Helps improve app speed and user experience.",
      items: [
        {
          name: "UI_PREFERENCE_NODE",
          purpose: "Saves user settings like theme and layout."
        },
        {
          name: "LATENCY_TRACKER",
          purpose: "Tracks app performance and loading speed."
        }
      ]
    },
    {
      id: "analytics",
      title: "Analytics Cookies",
      icon: Search,
      desc: "Used to understand how users interact with the app.",
      items: [
        {
          name: "VISITOR_METRICS_ANON",
          purpose: "Tracks anonymous user activity."
        },
        {
          name: "ERROR_LOG_RELAY",
          purpose: "Stores errors to improve the system."
        }
      ]
    }
  ];

  return (
    <div className="cp-portal">
      <Navigation />

      <div className="cp-grid-overlay"></div>
      <div className="cp-scanline"></div>

      <main className="cp-content">
        <header className="cp-hero">
          <div className="cp-hud-badge">
            <ShieldCheck size={14} />
            <span>COOKIE_POLICY</span>
          </div>

          <h1>
            Cookie <span className="text-gradient">Policy</span>
          </h1>

          <p>
            We use cookies to keep the platform secure, fast, and easy to use.
          </p>
        </header>

        <section className="cp-matrix">
          {cookieCategories.map((cat) => {
            const Icon = cat.icon;

            return (
              <div key={cat.id} className="cp-matrix-section">
                <div className="cp-section-header">
                  <div className="cp-section-icon">
                    <Icon size={24} />
                  </div>
                  <h2>{cat.title}</h2>
                </div>

                <p className="cp-matrix-desc">{cat.desc}</p>

                <div className="cp-cookie-list">
                  {cat.items.map((item, idx) => (
                    <div key={idx} className="cp-cookie-item">
                      <h4>{item.name}</h4>
                      <p>{item.purpose}</p>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </section>

        <section className="cp-consent-node">
          <h3>
            Manage <span className="text-gradient">Preferences</span>
          </h3>

          <p>
            You can control cookie settings from your browser or app settings.
          </p>

          <div style={{ marginTop: "2rem" }}>
            <button className="cp-btn">Update Preferences</button>
          </div>
        </section>
      </main>

      <FooterSection />
    </div>
  );
};

export default CookiePolicy;